import type { DisplayModes } from './Autocomplete'

export type Actions =
  | {
      type: ActionTypes.SetSearching
    }
  | {
      type: ActionTypes.ClearSearching
    }
  | {
      type: ActionTypes.SelectOption
      label: string
      value: string
    }
  | {
      type: ActionTypes.Clear
    }
  | {
      type: ActionTypes.ClearSelecting
    }
  | {
      type: ActionTypes.RegisterGroup
      id: string
      data: { display: DisplayModes; hasChildren: boolean }
    }
  | {
      type: ActionTypes.UnregisterGroup
      id: string
    }
  | {
      type: ActionTypes.SetMinWidth
      value: string
    }

export enum ActionTypes {
  Clear,
  ClearSearching,
  ClearSelecting,
  RegisterGroup,
  SelectOption,
  SetSearching,
  UnregisterGroup,
  SetMinWidth,
}
